import { Form, InputGroup } from "react-bootstrap";
import { DateInput } from ".";

interface DateTimeInputsProps {
    dateAccessor: string;
    timeAccessor: string;
    label?: string;
    inlineLabel?: boolean;
    dateAriaLabel?: string;
    timeAriaLabel?: string;
    ignoreTimeZone?: boolean;
    inGroup?: boolean;
    dateFormat?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
}

export function DateTimeInputs({
    dateAccessor,
    timeAccessor,
    label,
    inlineLabel,
    dateAriaLabel,
    timeAriaLabel,
    ignoreTimeZone,
    inGroup,
    dateFormat,
    required,
    disabled,
    readOnly,
}: Readonly<DateTimeInputsProps>) {
    if (!inGroup)
        return (
            <div className={`${inlineLabel ? "d-flex align-items-center" : ""} mb-2`}>
                {!!label && (
                    <div>
                        <Form.Label style={{ whiteSpace: "nowrap" }} className={inlineLabel ? "me-2" : ""}>
                            {label} {required && <span className="text-danger">*</span>}
                        </Form.Label>
                    </div>
                )}
                <InputGroup>
                    <DateInput
                        accessor={dateAccessor}
                        placeholderText="Date"
                        inGroup
                        aria-label={dateAriaLabel ?? "Date"}
                        ignoreTimeZone={ignoreTimeZone}
                        dateFormat={dateFormat}
                        required={required}
                        disabled={disabled}
                        readOnly={readOnly}
                    />
                    <DateInput
                        accessor={timeAccessor}
                        onlyTime
                        placeholderText="Time"
                        inGroup
                        aria-label={timeAriaLabel ?? "Time"}
                        ignoreTimeZone={ignoreTimeZone}
                        required={required}
                        disabled={disabled}
                        readOnly={readOnly}
                    />
                </InputGroup>
            </div>
        );

    return (
        <>
            <DateInput
                accessor={dateAccessor}
                placeholderText="Date"
                inGroup
                aria-label={dateAriaLabel ?? "Date"}
                ignoreTimeZone={ignoreTimeZone}
                disabled={disabled}
                readOnly={readOnly}
            />
            <DateInput
                accessor={timeAccessor}
                onlyTime
                placeholderText="Time"
                inGroup
                aria-label={timeAriaLabel ?? "Time"}
                ignoreTimeZone={ignoreTimeZone}
                disabled={disabled}
                readOnly={readOnly}
            />
        </>
    );
}
